<template>
  <div class="company-info" :style="warpperStyle">
    <div class="invoice_nav">
      <navbar
        title="供应方申请"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.7rem'"
        :titlecolor="'#333'"
        @goback="goBack(false)"
      />
    </div>
    <div class="content">
      <div class="tips">请完善以下信息，并签署合同</div>
      <div class="tips2">
        填写供应方资料<span>（{{ type }}）</span>
      </div>
      <div v-show="step == 1">
        <div class="invoice_info van-clearfix">
          <p class="title">
            <span class="ww">供应方信息</span>
            <span class="border"></span>
          </p>
          <div class="basic_info">
            <van-field
              v-model="supplierInfo.supplier_shop_name"
              label="公司名称"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.legal_person_name"
              label="法定代表人"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.credit_code"
              label="统一社会信用代码"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/[^\w]/ig,'')"
              onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.address_name"
              label="所在省市区"
              format-trigger="onBlur"
              class="marTop12"
              placeholder="请选择 >"
              readonly
              @click="selectAddress(1)"
            />
            <van-field
              v-model="supplierInfo.address_detail"
              label="详细地址"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
          </div>
        </div>
        <div class="invoice_info van-clearfix">
          <p class="title">
            <span class="ww">对公账户信息</span>
            <span class="border"></span>
          </p>
          <div class="basic_info">
            <van-field
              v-model="supplierInfo.account_name"
              label="开户名"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.account_bank"
              label="开户行"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.account_branch_bank"
              label="开户支行"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.account_number"
              label="账号"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              type="number"
            />
          </div>
        </div>
      </div>
      <div v-show="step == 2">
        <div class="invoice_info van-clearfix">
          <p class="title">
            <span class="ww">退换货信息</span>
            <span class="border"></span>
          </p>
          <div class="basic_info">
            <van-field
              v-model="supplierInfo.refund_name"
              label="收货人"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
            <van-field
              v-model="supplierInfo.refund_mobile"
              label="联系方式"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              type="number"
            />
            <van-field
              v-model="supplierInfo.refund_province_and_city"
              label="所在区域"
              format-trigger="onBlur"
              class="marTop12"
              placeholder="请选择 >"
              readonly
              @click="selectAddress(2)"
            />
            <van-field
              v-model="supplierInfo.refund_address"
              label="详细地址"
              format-trigger="onBlur"
              class="marTop12 licensse"
              placeholder="请输入"
              onkeyup="value=value.replace(/![u4e00-u9fa5]/ig,'')"
              onafterpaste="this.value=this.value.replace(/![u4e00-u9fa5]/ig,'')"
            />
          </div>
        </div>
        <p class="tip">说明：若发生退换货，商品将退到该地址</p>
        <div class="invoice_info van-clearfix last">
          <p class="title">
            <span class="ww">其他信息</span>
            <span class="border"></span>
          </p>
          <div class="basic_info">
            <span class="unit" @click="showUnitPopup">
              {{ unit }}<span class="icon"><van-icon name="play" /></span>
            </span>
            <van-field
              v-model="supplierInfo.delivery_time"
              label="发货时间"
              class="marTop12 licensse"
              placeholder="请输入"
              type="digit"
              pattern="digit"
            />
            <p class="invoice_type">
              发票类型
              <span class="active" v-if="typeIndex == 2">增值税专用发票</span>
              <span class="active" v-if="typeIndex == 1">增值税普通发票</span>
            </p>
          </div>
        </div>
        <p class="tip">
          说明：乙方提现后需提供发票（发票可以在每个月末合并提供一次）
        </p>
      </div>
    </div>
    <div class="complete" :style="completeStyle">
      <van-button
        v-show="step == 1"
        @click="next"
        type="primary"
        class="operation_btn"
      >
        下一步
      </van-button>
      <van-button
        v-show="step == 2"
        @click="submit"
        type="primary"
        class="operation_btn"
      >
        去签署合同
      </van-button>
      <div class="complete-empty"></div>
    </div>

    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>

    <van-popup v-model="show" position="bottom" :style="{ height: '16.4rem' }">
      <p class="title">选择时间单位</p>
      <p @click="changeUnit(1)">天</p>
      <p @click="changeUnit(2)">小时</p>
    </van-popup>

    <van-popup v-model="showArea" position="bottom" :overlay="true">
      <!--@change="onChange"-->
      <!-- <van-area
        :area-list="areaList"
        @cancel="cancel"
        @confirm="confirm($event)"
      /> -->
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="areaList"
        @close="showArea = false"
        @finish="onFinish"
      />
    </van-popup>
  </div>
</template>

<script>
import navbar from "../components/nav-bar.vue";
import { uploadMixin } from "../../../providers/mixin";
export default {
  data() {
    return {
      supplierInfo: {
        // supplier_shop_name: "",
        // legal_person_name: "",
        // credit_code: "",
        // address_name: "",
        // address_detail: "",
        // account_name: "",
        // account_bank: "",
        // account_branch_bank: "",
        // account_number: "",
        // refund_name: "",
        // refund_mobile: "",
        // refund_province_and_city: "",
        // refund_address: "",
        // contract_type: "",
        // delivery_type: 2,
        // delivery_time: "",
      },
      areaIndex: 0,
      warpperStyle: { height: "100%" },
      completeStyle: { bottom: "0" },
      loading: false,
      lefticon: require("@/assets/accountAgent/common/back.png"),
      typeIndex: 0,
      show: false,
      unit: "小时",
      step: 1,
      base_file_url: "",
      showArea: false,
      list: [],
      areaList: [],
      cascaderValue: "",
      type: "",
      // areaList: {
      //   province_list: {
      //     // 110000: "北京市",
      //     // 120000: "天津市",
      //   },
      //   city_list: {
      //     // 110100: "北京市",
      //     // 120100: "天津市",
      //   },
      //   county_list: {
      //     // 110101: "东城区",
      //     // 110102: "西城区",
      //   },
      // },
    };
  },
  components: {
    navbar,
  },
  created() {
    this.type = this.$route.query.type;
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.getArea();
    this.getInfo();
  },
  mounted() {
    document
      .querySelector(".content")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  mixins: [uploadMixin],
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    showUnitPopup() {
      this.show = true;
    },
    changeUnit(index) {
      this.supplierInfo.delivery_type = index;
      this.unit = index == 1 ? "天" : "小时";
      this.show = false;
    },
    getArea() {
      this.$api.get("/platformsys/index/areas/list", {}).then((res) => {
        this.list = res.list;
        this.areaList = [];
        this.list.forEach((_) => {
          let item = {};
          item.text = _.name;
          item.value = _.code;
          if (_.children && _.children.length > 0) {
            item.children = [];
            _.children.forEach((__) => {
              let item1 = {};
              item1.text = __.name;
              item1.value = __.code;
              item.children.push(item1);
              if (__.children && __.children.length > 0) {
                item1.children = [];
                __.children.forEach((___) => {
                  let item2 = {};
                  item2.text = ___.name;
                  item2.value = ___.code;
                  item1.children.push(item2);
                });
              }
            });
          }
          this.areaList.push(item);
        });
      });
    },
    getInfo() {
      this.$api
        .post("/member-relation/member/three/year/supplier/contract-info", {
          supplier_id: this.$route.query.supplier_id,
        })
        .then((res) => {
          res.delivery_type = 2;
          res.tax_type = this.type;
          if (this.type == "小规模纳税人") {
            res.contract_type = "增值税普通发票";
            this.typeIndex = 1;
          } else {
            res.contract_type = "增值税专用发票";
            this.typeIndex = 2;
          }
          this.supplierInfo = res;
          this.unit = "小时";
        });
    },
    // confirm(selected) {
    //   this.showArea = false;
    //   if (this.areaIndex == 1) {
    //     this.supplierInfo.address_name = "";
    //   } else {
    //     this.supplierInfo.refund_province_and_city = "";
    //   }

    //   for (var i = 0; i < selected.length; i++) {
    //     if (this.areaIndex == 1) {
    //       this.supplierInfo.address_name =
    //         this.supplierInfo.address_name + selected[i].name + " ";
    //     } else {
    //       this.supplierInfo.refund_province_and_city =
    //         this.supplierInfo.refund_province_and_city + selected[i].name + " ";
    //     }
    //   }
    // },
    // cancel() {
    //   this.showArea = false;
    // },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.showArea = false;
      if (this.areaIndex == 1) {
        this.supplierInfo.address_name = "";
      } else {
        this.supplierInfo.refund_province_and_city = "";
      }
      if (this.areaIndex == 1) {
        this.supplierInfo.address_name = selectedOptions
          .map((option) => option.text)
          .join(" ");
      } else {
        this.supplierInfo.refund_province_and_city = selectedOptions
          .map((option) => option.text)
          .join(" ");
      }
    },
    selectAddress(index) {
      this.areaIndex = index;
      this.showArea = true;
      this.cascaderValue = "";
    },
    next() {
      if (!this.supplierInfo.supplier_shop_name) {
        this.$toast("请填写公司名称");
        return;
      } else if (!this.supplierInfo.legal_person_name) {
        this.$toast("请填写法定代表人");
        return;
      } else if (!this.supplierInfo.credit_code) {
        this.$toast("请填写统一社会信用代码");
        return;
      } else if (!this.supplierInfo.address_name) {
        this.$toast("请填写所在省市区");
        return;
      } else if (!this.supplierInfo.address_detail) {
        this.$toast("请填写详细地址");
        return;
      } else if (!this.supplierInfo.account_name) {
        this.$toast("请填写开户名");
        return;
      } else if (!this.supplierInfo.account_bank) {
        this.$toast("请填写开户行");
        return;
      } else if (!this.supplierInfo.account_branch_bank) {
        this.$toast("请填写开户支行");
        return;
      } else if (!this.supplierInfo.account_number) {
        this.$toast("请填写账号");
        return;
      } else {
        this.step = 2;
      }
    },
    submit() {
      this.loading = true;
      let url;
      if (this.$route.query.resign == 1) {
        url = "member-relation/member/three/year/supplier/resign";
      } else {
        url = "member-relation/member/three/year/supplier/supplier-contract";
      }
      this.$api
        .post(url, this.supplierInfo)
        .then((res) => {
          this.loading = false;
          this.base_file_url = res.base_file_url;
        })
        .catch((err) => {
          this.loading = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        })
        .finally(() => {
          this.loading = false;
          if (this.base_file_url) this.toSign();
        });
    },
    toSign() {
      let parm = {};
      if (this.$route.query.resign == 1) {
        parm = {
          url: this.base_file_url,
          is_resign: 1,
        };
      } else {
        parm = {
          url: this.base_file_url,
          is_resign: 0,
        };
      }
      this.params(JSON.stringify(parm), JSON.stringify(parm), "toSign");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less">
.company-info {
  overflow-x: hidden;
  padding: 9.2rem 0 5rem;
  box-sizing: border-box;
  color: #333;
  font-size: 1.4rem;
  background: #f5f6f7;

  .invoice_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }
  .content {
    .tips {
      height: 5.4rem;
      line-height: 5.4rem;
      color: #333;
      font-size: 1.6rem;
      font-weight: 700;
      padding: 0 1.6rem;
    }

    .tips2 {
      height: 6rem;
      line-height: 6.8rem;
      color: #333;
      font-size: 2rem;
      font-weight: 700;
      padding: 0 1.6rem;
      background: #fff;

      span {
        color: #f73e28;
        font-size: 1.5rem;
      }
    }

    .invoice_info {
      background: #fff;
      padding: 1rem 1.6rem 0;
      box-sizing: border-box;
      margin-bottom: 1.2rem;

      .title {
        height: 5rem;
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        position: relative;
        padding: 1.5rem 0;
        box-sizing: border-box;

        .ww {
          height: 2rem;
          line-height: 2rem;
          position: absolute;
          left: 0;
          top: 1.5rem;
          z-index: 1;
        }

        .border {
          width: 5.1rem;
          height: 0.4rem;
          display: inline-block;
          position: absolute;
          bottom: 1.7rem;
          left: 0;
          z-index: 0;
          background: -webkit-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
        }
      }

      .van-cell {
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: " ";
          pointer-events: none;
          right: 0;
          bottom: 0;
          left: 0 !important;
          border-bottom: 1px solid #ebedf0;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
        }
      }
      input::placeholder {
        color: #bababa;
        font-size: 14px;
      }
      .marTop12 {
        // margin-top: 12px;
        .van-field__control {
          font-size: 1.4rem;
          text-align: right;
        }
      }
      .basic_info {
        .van-cell {
          padding: 15px 0;
          &:not(:last-child)::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 16px;
            border-bottom: 1px solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
          }
        }
        .van-field__label {
          font-size: 1.4rem;
          color: #333;
          font-weight: bold;
          width: 11.5rem;
          margin-right: 1.5rem;
        }
      }
    }

    .last {
      .van-cell__value {
        padding-right: 6rem;
      }

      .basic_info {
        position: relative;

        .unit {
          color: #333;
          font-size: 1.4rem;
          height: 5.4rem;
          line-height: 5.4rem;
          display: inline-block;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;

          .icon {
            float: right;
            margin-top: -0.3rem;
          }

          .van-icon {
            margin-left: 0.7rem;
            width: 0.5rem;
            transform: translateY(-3px);
            transform: rotate(90deg);
            -ms-transform: rotate(90deg); /* IE 9 */
            -moz-transform: rotate(90deg); /* Firefox */
            -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
            -o-transform: rotate(90deg);
          }
        }

        .invoice_type {
          height: 5.4rem;
          line-height: 5.4rem;
          color: #333;
          font-size: 1.4rem;
          font-weight: 700;

          span {
            float: right;
            width: 10rem;
            text-align: center;
            height: 2.6rem;
            line-height: 2.6rem;
            display: inline-block;
            margin-left: 1rem;
            border-radius: 0.4rem;
            margin-top: 1.4rem;
            color: #666;
            font-size: 1.2rem;
            font-weight: 400;
            border: solid 0.05rem #999;
          }

          .active {
            color: #fff;
            font-size: 1.2rem;
            font-weight: 400;
            border: none;
            height: 2.7rem;
            background: -webkit-linear-gradient(
              to right,
              #fc740c,
              #f41a3c
            ); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(
              to right,
              #fc740c,
              #f41a3c
            ); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(
              to right,
              #fc740c,
              #f41a3c
            ); /* Firefox 3.6 - 15 */
            background: linear-gradient(to right, #fc740c, #f41a3c);
          }
        }
      }
    }

    .tip {
      color: #999;
      font-size: 1.2rem;
      line-height: 1.7rem;
      margin: -0.2rem 0 2.1rem;
    }
  }
  .complete {
    position: fixed;
    z-index: 3;
    // bottom: 0;
    padding: 0.4rem 12px;
    // width: calc(100% - 24px);
    box-sizing: border-box;
    background: #fff;
    width: 100%;
    transition: bottom 0.1s linear;
    .complete-empty {
      height: 4px;
      width: 100%;
    }
    .operation_btn {
      color: #fff;
      border: none;
      width: 100%;
      margin: 0 auto;
      height: 44px;
      font-size: 16px;
      display: block;
      border-radius: 22px;
      line-height: 44px;
      font-weight: 600;
      background: -webkit-linear-gradient(to right, #fc740c, #f41a3c);
      /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to right, #fc740c, #f41a3c);
      /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to right, #fc740c, #f41a3c);
      /* Firefox 3.6 - 15 */
      background: linear-gradient(to right, #fc740c, #f41a3c);
    }
  }
  .van-uploader__preview-delet {
    font-size: 26px;
  }

  .tip {
    padding: 0 10px;
    text-align: left;
  }
  .tipL {
    margin-bottom: 24px;
  }
  .van-dialog__header {
    padding: 20px 0 24px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

  .van-popup {
    p {
      color: #333;
      font-size: 1.6rem;
      height: 4.9rem;
      line-height: 4.9rem;
      text-align: center;
      border-bottom: solid 1px #eee;
    }

    .title {
      color: #999;
      font-size: 1.4rem;
      height: 6.4rem;
      line-height: 6.4rem;
    }
  }
}
</style>





